export function createEmptyPostcard() {
  return {
    category: '',
    recipient: '',
    recipientPronouns: '',
    tone: '',
    occasion: '',
    style: '',
    userIntent: '',
    poemStyle: '',
    songLyrics: '',
    affirmation: '',
    joke: '',
    story: '',
    note: '',
    customStyle: '',
    customOccasion: '',
    customPronouns: '',
    fromField: '',
    recipientFirstName: '',
    recipientLastName: '',
    address: {
      street: '',
      optional: '',
      city: '',
      state: '',
      postalCode: '',
      country: '',
    },
    message: '',
    imageFromDALLEUrl: '',
  };
}

export const recipients = {
  Family: [
    'Mother',
    'Father',
    'Parent',
    'Brother',
    'Sister',
    'Sibling',
    'Brother In-Law',
    'Sister In-Law',
    'Son',
    'Daughter',
    'Child',
    'Grandmother',
    'Grandfather',
    'GrandParent',
    'Aunt',
    'Uncle',
    'Cousin',
    'Niece',
    'Nephew'
  ],
  Friends: [
    'Best Friend',
    'Close Friend',
    'Childhood Friend',
    'College Friend',
    'Work Friend',
    'Neighbor',
    'Acquaintance'
  ],
  Romantic: [
    'Boyfriend',
    'Girlfriend',
    'Husband',
    'Wife',
    'Fiancé',
    'Fiancée',
    'Partner',
    'Crush',
    'Significant Other'
  ]
};

export const tones = {
  Family: [
    'Playful',
    'Goofy',
    'Loving',
    'Supportive',
    'Proud',
    'Grateful',
    'Warm',
    'Encouraging',
    'Nostalgic'
  ],
  Friends: [
    'Playful',
    'Goofy',
    'Fun',
    'Supportive',
    'Morbid',
    'Thankful',
    'Cheerful',
    'Weird',
    'Encouraging',
    'Nostalgic'
  ],
  Romantic: [
    'Playful',
    'Goofy',
    'Romantic',
    'Spicy',
    'Passionate',
    'Sexy',
    'Loving',
    'Flirty',
    'Devoted',
    'Supportive',
    'Thankful',
    'Encouraging'
  ],
  Other: [
    'Professional',
    'Formal',
    'Appreciative',
    'Respectful',
    'Inspirational',
    'Encouraging',
    'Congratulatory',
    'Motivational',
    'Warm'
  ]
};

export const styles = [
  'Poem',
  'Song lyrics',
  'Story',
  'Joke',
  'Affirmation',
  "Note",
  'Surprise Me'
];

export const substyles = {
  Poem: [
    'Haiku',
    'Mini Ode',
    'Classic Verse',
    'Free Verse',
    'Mini Sonnet',
    'Short Quatrain',
    'Personal Verse',
    'Micro Poem',
    'Other',
    'Surprise Me',
  ],
  SongLyrics: [
    'Pop',
    'Rock',
    'Country',
    'Metal',
    'Grunge',
    'Hip-Hop',
    'R&B',
    'Indie',
    'Other',
    'Surprise me',
  ],
  Affirmation: [
    'Gentle Reassurance',
    'Bold Motivation',
    'Quiet Strength',
    'Hope After Hurt',
    'Other',
    'Surprise Me',
  ],
  Story: [
    'Adventure',
    'Fairy Tale',
    'Mystery',
    'Sci-Fi',
    'Fantasy',
    'Western',
    'Horror',
    'Other',
    'Surprise Me',
  ],
  Joke: [
    'One-Liner',
    'Puns & Wordplay',
    'Dad Joke',
    'Dark Humor',
    'Absurdist',
    'Other',
    'Surprise Me',
  ],
  Notes: [
    'Missing You',
    'Friendly Check-In',
    'Simple Thank You',
    'Thinking of U',
    'Apology',
    'Encouragement',
    'Just Because',
    'Other',
    'Surprise Me',
  ]
};
